import React from "react";
import FoundationHero from "./components/HeroSection/HeroSection";
import FoundationImpact from "./components/Impact/Impact";
import AboutUs from "./components/About/About";
import ProgramsScholarships from "./components/Programs/Programs";
import Partnerships from "./components/Partnership/Partnership";
import DonationSection from "./components/DonateSection/DonateSection";
import ContactSection from "./components/Contact/Contact";

function Main() {
  return (
    <div>
      <FoundationHero />
      <AboutUs />
      <FoundationImpact />
      <ProgramsScholarships />
      <Partnerships />
      <DonationSection />
      <ContactSection />
    </div>
  );
}

export default Main;
